import React, { useEffect, useState } from "react";
import { bindActionCreators } from "redux";
import { Alert, Card, CardBody, Col, Container, Row } from "reactstrap";
import { connect } from "react-redux";
import { addExpense, getExpenses } from "store/actions/Expenses";
import { RootState } from "../../store/store";
import PageMeta from "components/PageMeta";
import LedgerAccountSelect from "components/LedgerAccountSelect";
import {
    UncategorizedLedgerAccount,
    getExpenseLedgerAccount,
    getLastExpenseLedgerAccount,
    setExpenseLedgerAccount
} from "common/LedgerAccounts";
import { Expense } from "models/Expense";
import { Account } from "models/Account";
import * as api from "services/Api";
import { GetRouterQuery } from "components/Utils/GetRouterQuery";
import { useNavigate } from "react-router";
//@ts-ignore
import Select from 'react-select'
import { ExpenseState } from 'store/reducers/Expenses';
import {useOfficeTranslation} from 'i18n/OfficeTranslation';
// import DropzoneCustom from "components/DropzoneCustom";
// import { File } from "models/File";

interface Props {
    expenseState: ExpenseState;
}

interface Actions {
    getExpenses: () => void;
    addExpense: (e: Expense) => void;
}

const ExpenseAddForm: React.FC<Props & Actions> = ({ expenseState, getExpenses, addExpense }) => {
    const {t} = useOfficeTranslation();
    // const [selectedFiles, setselectedFiles] = useState<File[]>([]);
    const [expense, setExpense] = useState(new Expense())
    const [accounts, setAccounts] = useState<Account[]>([])
    const [accountId, setAccountId] = useState("")
    const [error, setError] = useState<string | null>(null)
    const { id } = GetRouterQuery<{ id: string }>()

    const navigate = useNavigate();

    useEffect(() => {
        getExpenses()
        api.getAccounts("supplier").then(items => setAccounts(items.filter(account => account.tenant === id))).catch(() => setAccounts([]))
    }, [getExpenses, id])

    useEffect(() => {
        if (getExpenseLedgerAccount(expense) !== UncategorizedLedgerAccount) {
            return;
        }

        if (!accountId) {
            return;
        }

        const accountExpenses = expenseState.getExpensesByAccountId(accountId);
        const ledgerAccount = getLastExpenseLedgerAccount(accountExpenses);

        if (ledgerAccount !== UncategorizedLedgerAccount) {
            const nextExpense = Object.assign(new Expense(), expense);
            setExpenseLedgerAccount(nextExpense, ledgerAccount);
            setExpense(nextExpense);
        }
    }, [accountId, expense, expenseState])


    const Save = () => {
        if (
            (expense.name !== undefined && expense.total !== undefined && accountId)
        ) {

            expense.tenant = id;
            expense.account_id = accountId;
            expense.account = accounts.find(account => account.id === accountId)!;

            addExpense(expense)
                //@ts-ignore
                .then(() => {
                    navigate("/tenants/" + id + "/expenses");
                })
                .catch((e: any) => {
                    console.log(e)
                    setError(t("common.expensesHasFailedCheckYourCredentials"))
                });

        } else {
            setError(t("common.nameAndTotalAreMandatory"))
        }


    }

    return (
        <>
            <PageMeta title={t("common.addExpense")} />
            <div className="page-content">
                <div className="page-title-box d-flex align-items-center justify-content-between">
                    <h2 className="mb-0 font-size-120">{t("expenses.expenseAddForm.addNewExpense")}</h2>
                </div>
                {
                    error &&
                    <Alert color="danger">{error}</Alert>
                }
                <Container fluid>
                    <Row>
                        <Col >
                            <Card>
                                <CardBody>
                                    <p className="text-muted text-uppercase fw-semibold mb-0" style={{ fontSize: "20px" }}>{t("common.details")}</p>
                                    <div className="dropdown-divider"></div>

                                    <div className="mb-3">
                                        <label className="form-label">{t("expenses.expenseAddForm.orChooseExistingSupplier")}</label>
                                        <Select
                                            options={accounts.map(account => ({ value: account.id, label: account.legal_name }))}
                                            onChange={(option: any) => setAccountId(option?.value ?? "")}
                                        />
                                    </div>

                                    <div className="form-floating mb-3">
                                        <input type="text" className="form-control" defaultValue={expense.name} onChange={e => {
                                            expense.name = e.target.value
                                            setExpense(expense)
                                        }} placeholder={t("common.name")} />
                                        <label className="Name">{t("common.name")}</label>
                                    </div>

                                    <div className="mb-3">
                                        <input className="form-control" type="date" id="example-date-input" onChange={e => {
                                            expense.date = new Date(e.target.value)
                                            setExpense(expense)
                                        }} />
                                    </div>


                                    <div className="form-floating mb-3">
                                        <input type="number" className="form-control" defaultValue={expense.tax} onChange={e => {
                                            expense.tax = parseFloat(e.target.value)
                                            setExpense(expense)
                                        }} placeholder={t("common.tax")} />
                                        <label className="Tax">{t("common.tax")}</label>
                                    </div>

                                    <div className="form-floating mb-3">
                                        <input type="number" className="form-control" defaultValue={expense.total} onChange={e => {
                                            expense.total = parseFloat(e.target.value)
                                            setExpense(expense)
                                        }} placeholder={t("common.total")} />
                                        <label className="Total">{t("common.total")}</label>
                                    </div>

                                    <div className="mb-3">
                                        <label className="form-label">{t("common.ledgerAccount")}</label>
                                        <LedgerAccountSelect
                                            value={getExpenseLedgerAccount(expense)}
                                            onChange={value => {
                                                const nextExpense = Object.assign(new Expense(), expense);
                                                setExpenseLedgerAccount(nextExpense, value);
                                                setExpense(nextExpense);
                                            }}
                                        />
                                    </div>

                                    {/* <DropzoneCustom selectedFiles={selectedFiles} setselectedFiles={setselectedFiles} /> */}


                                    <div className="mt-3">
                                        <button
                                            id="buttonCustomer"
                                            name="buttonCustomer"
                                            className="btn btn-primary w-100 waves-effect waves-light"
                                            type="button"
                                            onClick={() => {
                                                Save()
                                            }}
                                        >
                                            {t("common.save")}
                                        </button>
                                    </div>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>
        </>
    );
};

const mapStateToProps = (state: RootState) => {
    return {
        expenseState: state.Expenses
    };
};

const mapDispatchToProps = (dispatch: any) => {
    return bindActionCreators({ getExpenses, addExpense }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(ExpenseAddForm);
